import { render, staticRenderFns } from "./platformDeposit.vue?vue&type=template&id=10a7d1b4&scoped=true"
import script from "./platformDeposit.vue?vue&type=script&lang=js"
export * from "./platformDeposit.vue?vue&type=script&lang=js"
import style0 from "./platformDeposit.vue?vue&type=style&index=0&id=10a7d1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a7d1b4",
  null
  
)

export default component.exports